import { Button, Dialog, DialogActions, DialogContent, Grid, Typography } from "@mui/material"
import { useFormikContext } from "formik"
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router"

export function RouterPrompt(props) {
  const { t } = useTranslation()
  const formik = useFormikContext()
  const history = useHistory()

  const [showPrompt, setShowPrompt] = useState(false)
  const [currentPath, setCurrentPath] = useState("")

  const unblockRef = useRef()

  function handleShowModal() {
    setShowPrompt(true)
  }

  function handleCancel() {
    setShowPrompt(false)
  }

  useEffect(() => {
    if (formik.dirty && formik.submitCount === 0) {
      unblockRef.current = history.block((location) => {
        setCurrentPath(location.pathname)
        handleShowModal()
        return false
      })
    }
    return () => {
      unblockRef.current && unblockRef.current()
    }
  }, [formik, history])

  function handleOK() {
    if (unblockRef) {
      unblockRef.current()
    }
    setShowPrompt(false)
    history.push(currentPath)
  }

  return showPrompt ? (
    <Dialog
      open={showPrompt}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs">
      <Grid container direction="column" alignItems="center">
        <DialogContent my={2}>
          <Typography variant="h4" paragraph>
            {t("global.you_have_unsaved_changes", "You have unsaved changes")}
          </Typography>
          <Typography variant="bodySmall" paragraph>
            {t("global.are_you_sure_you_want_to_leave_page", "Are you sure you want to leave the page?")}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            {t("global.remain", "Remain")}
          </Button>
          <Button onClick={handleOK} color="primary" variant="contained">
            {t("global.leave_page", "Leave Page")}
          </Button>
        </DialogActions>
      </Grid>
    </Dialog>
  ) : null
}
